<div class="challenge_item" [class]="this.responseChallengeStatus.classCSS" [class.clickable]="this.isClickable" (click)="this.selectChallenge()">
    <div class="challenge_item_title_content">
        <div class="challenge_item_title">
            {{this.challenge.title | translate}}
            @if(['demonstration', 'sale'].indexOf(this.challenge.type) !== -1 
                && !this.challenge.response?.status
                && (this.challenge.target && this.challenge.target > 0)
            ){                
                ({{(this.challenge.target - (this.challenge.done || 0))}})
            }
        </div>
        @if(this.levelLabel){
            <div class="challenge_item_level">{{this.levelLabel}}</div>
        }
        <div class="challenge_item_status">{{this.responseChallengeStatus.label | translate}}</div>
        @if(this.dateChallenge !== ''){
            <div class="challenge_item_response_date">{{this.dateChallenge}}</div>
        }
    </div>
    <div class="challenge_item_description">{{this.description}}</div>
    <div class="challenge_item_incentives" [class.lost_incentives]="this.lostIncentives">
        @if(this.incentivePointsLabel != ''){
            <div class="challenge_item_incentive incentive_points" [innerHTML]="this.incentivePointsLabel"></div>
        }
        @if(this.incentiveLabel != ''){
            <div class="challenge_item_incentive" [innerHTML]="this.incentiveLabel"></div>
        }
    </div>
</div>